import { createTabContext } from "../../components";

import { CheckinTabs } from "./types";

export const [TabContext, useTabContext] = createTabContext<CheckinTabs>();
